import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { ASTAR_URL } from "@util/constant";

/**
 * Component to render Astar section on Partners page
 */
const AstarSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="astar-section-component">
      <AccordionV2
        testId="astar"
        className="border-none py-2"
        headerChildren={
          <EventsAwardsAccordionHeader
            title="Agency for Science, Technology and Research (A*STAR)"
            className="px-0"
          />
        }
        arrowClassName="h-auto w-auto -rotate-90 border-none"
        isArrowRight
      >
        <div className="px-6 pb-2 pt-6">
          <p>
            The Agency for Science, Technology and Research (A*STAR) is
            Singapore&apos;s lead public sector R&D agency, spearheading
            economic-oriented research to advance scientific discovery and
            develop innovative technology. Through open innovation, we
            collaborate with our partners in both the public and private sectors
            to benefit society.
          </p>

          <p>
            As a Science and Technology Organisation, A*STAR bridges the gap
            between academia and industry. Our research creates economic growth
            and jobs for Singapore, and enhances lives by contributing to
            societal benefits such as improving outcomes in healthcare, urban
            living, and sustainability.
          </p>

          <p>
            We play a key role in nurturing and developing a diversity of talent
            and leaders in our Agency and research entities, the wider research
            community and industry. A*STAR’s R&D activities span biomedical
            sciences and physical sciences and engineering, with research
            entities primarily located in Biopolis and Fusionopolis. For ongoing
            news, visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={ASTAR_URL}
              target="_blank"
              rel="noreferrer"
            >
              www.a-star.edu.sg
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default AstarSection;
